import React, { createContext, useContext, ReactNode } from 'react';

type RouteContextType = {
    isFromShared: boolean;
};

const RouteContext = createContext<RouteContextType>({
    isFromShared: false,
});

export const RouteProvider = ({
    children,
    isFromShared,
}: {
    children: ReactNode;
    isFromShared: boolean;
}) => {
    return (
        <RouteContext.Provider value={{ isFromShared }}>
            {children}
        </RouteContext.Provider>
    );
};

export const useRouteContext = () => useContext(RouteContext);
